<template>
  <Block tagName="div" type="onestoreSubscribeTimeItem" :active="!isCancel">
    <div class="onestore-subscribe-title-wrap">
      <Mark type="subscribeItemDetailTitle">{{ productDesc }}</Mark>
      <Mark type="subscribeItemDetailPrices1">{{ prices }}</Mark>
    </div>
    <!-- 未到期且没有取消，则提示续期日期 -->
    <Mark type="subscribeItemDetailTime" v-if="!isExpire && !isCancel">{{
      replaceDateAndPricesOfText({
        date: expiredTime,
        text: languages.onestore_subscribe_goon_sub,
      })
    }}</Mark>
    <!-- 已过期或未到期但取消了，则提示到期日期 -->
    <Mark type="subscribeItemDetailTime" v-else>{{
      replaceDateAndPricesOfText({
        date: expiredTime,
        text: languages.onestore_subscribe_expire_time,
      })
    }}</Mark>
    <Mark type="subscribeItemDetailPrices2">{{ prices }}</Mark>
  </Block>
</template>
<script>
import { replaceDateAndPricesOfText } from '@utiles/index';
import { mapState } from 'vuex';
export default {
  props: ['productDesc', 'expiredTime', 'prices', 'isCancel', 'isExpire'],
  computed: {
    ...mapState({
      languages: state => state.onestoreSubscribe.languages,
    }),
  },
  methods: {
    replaceDateAndPricesOfText,
  },
};
</script>
